<template>
    <div>
        <h1>Objednávka Velké knihy sádrokartonu (VKS)</h1>
        <ssv-order-header-vks/>
        <ssv-order-billing-information-container display-full-form ref="billingInformation"/>
        <ssv-order-contact-information-container required extended mkt-communication ref="contactInformation" :labels="contactLabels"/>
        <div class="ssv-form">
            <div class="input-item">
                <div class="input-item">
                    <label class="label" for="numberOfBooks">Počet kusů</label>
                    <input class="input input--s" type="number" id="numberOfBooks" step="1" v-model="numberOfBooks" oninput="this.value = !!this.value && Math.abs(this.value) > 0 ? Math.abs(this.value) : null">
                    <ssv-order-error-field field="additionalData.numberOfBooks"/>
                </div>
            </div>
        </div>
        <ssv-order-note placeholder="chcete-li nám cokoliv sdělit"/>
        <ssv-order-price-container/>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import SsvOrderBillingInformationContainer from '../billing-information/BillingInformationContainer';
import SsvOrderContactInformationContainer from '../contact-information/ContactInformationContainer';
import SsvOrderPriceContainer from '../price/PriceContainer';
import SsvOrderNote from '../parameters/OrderNote';
import SsvOrderHeaderVks from '../header/HeaderVks';
import SsvOrderErrorField from '../error/ErrorField';

export default {
    name:       'SsvOrderVks',
    components: {
        SsvOrderErrorField,
        SsvOrderHeaderVks,
        SsvOrderNote,
        SsvOrderPriceContainer,
        SsvOrderContactInformationContainer,
        SsvOrderBillingInformationContainer,
    },
    computed:   {
        ...mapFields('ssvOrder', [
            'additionalData.numberOfBooks',
        ]),
    },
    data() {
        return {
            contactLabels: {
                phone: 'Vyplňte prosím pro případ upřesnění údajů',
                email: 'Tato adresa slouží k vyřízení objednávky, zaslání informací o jejím stavu a účetních dokladů.',
            },
            billingLables: {
                anotherMailingAddress: 'mám jinou korespondenční adresu',
            }
        }
    },
    methods:    {
        validate() {
            this.$refs.billingInformation.validate();
            this.$refs.contactInformation.validate();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/order/Vks.vue